import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Drawer from '../Pages/Drawer'
function Header({ back }) {
    const [right, setright] = useState('-101%');
    const navigate = useNavigate();

    return (
        <>
            <Drawer right={right} change={setright} />
            <div className="flex-between px-3 header col-lg-4 home ">

                <div className="flex-between input-search">
                    {back ? <i onClick={() => { navigate(-1) }} className='far fa-arrow-right me-2'></i> : <i onClick={() => { setright(right == '-101%' ? 'unset' : '-101%') }} className='far fa-bars'></i>}
                    <div className='in' onClick={() => { navigate('/Search') }} >جستجو کنید ... </div>
                </div>
                <Link to={'/Messages'}><i className='fas fa-comments-alt'></i></Link>
            </div>

        </>
    )
}

export default Header